/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Term_L9Inputs */

const en_mk_term_l9 = /** @type {(inputs: Mk_Term_L9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ F1-T3 verified · commit a1b2c3d +214 −37 · 5/102 done`)
};

const id_mk_term_l9 = /** @type {(inputs: Mk_Term_L9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ F1-T3 terverifikasi · commit a1b2c3d +214 −37 · 5/102 rampung`)
};

/**
* | output |
* | --- |
* | "✓ F1-T3 verified · commit a1b2c3d +214 −37 · 5/102 done" |
*
* @param {Mk_Term_L9Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_term_l9 = /** @type {((inputs?: Mk_Term_L9Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Term_L9Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_term_l9(inputs)
	return en_mk_term_l9(inputs)
});